
var coll = document.getElementsByClassName("collapsible");
var i;
for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
}

let account_icon = document.querySelector(".header__icon--account");
account_icon.classList.remove("small-hide");




let tabs = document.querySelectorAll(
  ".rusu-filter .facet-filters__sort option"
);

tabs.forEach((tab, index) => {
  tab.addEventListener("click", () => {
    tabs.forEach((tab) => {
      tab.classList.remove("active");
      tab.removeAttribute("selected", "selected");
    });
    tab.classList.add("active");
    tab.setAttribute("selected", "selected");
  });
});


window.addEventListener("load", () => {
  var swiper = new Swiper(".product-slide", {
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
      el: "",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".seller_tab .products-tab .swiper-pagination",
      type: "progressbar",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
      1300: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
  // banner slide show slider
  var swiper = new Swiper(".mySwiper-banner-slider", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
  });
});

// Re-initialize the category slider on Shopify section reload
document.addEventListener("shopify:section:load", () => {
  var swiper = new Swiper(".product-slide", {
    slidesPerView: 2,
    spaceBetween: 20,
    pagination: {
      el: "",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".seller_tab .products-tab .swiper-pagination",
      type: "progressbar",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1300: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });
  // banner slide show slider
  var swiper = new Swiper(".mySwiper-banner-slider", {
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
    },
  });
});

// product page slider

window.addEventListener("load", () => {
  var swiper = new Swiper(".thumb-slide", {
    spaceBetween: 20,
    slidesPerView: 3,
    direction: "horizontal",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    breakpoints: {
      992: {
        slidesPerView: 3,
        direction: "vertical",
      },
    },
  });
  var swiper2 = new Swiper(".main-slide", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: swiper,
    },
  });
});

// Re-initialize the category slider on Shopify section reload
document.addEventListener("shopify:section:load", () => {
  var swiper = new Swiper(".thumb-slide", {
    spaceBetween: 20,
    slidesPerView: 3,
    direction: "horizontal",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        direction: "vertical",
      },
    },
  });
  var swiper2 = new Swiper(".main-slide", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: swiper,
    },
  });
});
// Re-initialize the category slider on Shopify section resize
document.addEventListener("resize", () => {
  var swiper = new Swiper(".thumb-slide", {
    slidesPerView: 3,
    direction: "horizontal",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        direction: "vertical",
      },
    },
  });
  var swiper2 = new Swiper(".main-slide", {
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: swiper,
    },
  });
});

let three = document.querySelector(".desktop.short-icon .three");
let four = document.querySelector(".desktop.short-icon .four");
let row_id = document.getElementById("product-grid");

three.addEventListener("click", () => {
  row_id.classList.add("grid--3-col-desktop");
  row_id.classList.remove("grid--4-col-desktop");
});
four.addEventListener("click", () => {
  row_id.classList.add("grid--4-col-desktop");
  row_id.classList.remove("grid--3-col-desktop");
});

let one = document.querySelector(".mobile.short-icon .svg1");
let two = document.querySelector(".mobile.short-icon .svg2");



two.addEventListener("click", () => {
  row_id.classList.remove("grid--1-col-tablet-down");
  row_id.classList.add("grid--2-col-tablet-down");
  two.style.display = "none";
  one.style.display = "block";
});

one.addEventListener("click", () => {
  row_id.classList.remove("grid--2-col-tablet-down");
  row_id.classList.add("grid--1-col-tablet-down");
  two.style.display = "block";
  one.style.display = "none";
});



